import { useEffect, useState } from "react";

// Follows `value` once it has stayed unchanged for `delayMs`; every change restarts the wait.
// The second item settles on a value right away. While `enabled` is false no timer runs.
export function useSettledValue<T>(value: T, delayMs: number, enabled = true): [T, (next: T) => void] {
    const [settled, setSettled] = useState<T>(value);

    useEffect(() => {
        if (!enabled || Object.is(value, settled)) return undefined;
        const timer = window.setTimeout(() => setSettled(value), delayMs);
        return () => window.clearTimeout(timer);
    }, [value, settled, delayMs, enabled]);

    return [settled, setSettled];
}
